import React from "react";
import { Box, LinearProgress, Typography, useTheme } from "@mui/material";
import { WorkflowCategoryData, StepStatus } from "../../../types/process";

interface ProcessProgressProps {
  category: WorkflowCategoryData;
}

const ProcessProgress: React.FC<ProcessProgressProps> = ({ category }) => {
  const theme = useTheme();

  const calculateProgress = () => {
    let totalSteps = 0;
    let completedSteps = 0;

    // Safety check for category and processes
    if (!category || !category.processes) {
      return 0;
    }

    category.processes.forEach(process => {
      if (process && process.steps) {
        totalSteps += process.steps.length;
        completedSteps += process.steps.filter(
          step => step.status === StepStatus.COMPLETE,
        ).length;
      }
    });

    return totalSteps > 0 ? (completedSteps / totalSteps) * 100 : 0;
  };

  const progress = calculateProgress();

  return (
    <Box sx={{ width: "100%", mt: 1 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 0.5,
        }}
      >
        <Typography
          variant="caption"
          sx={{
            color: "rgba(255,255,255,0.8)",
            fontSize: { xs: "0.7rem", sm: "0.75rem" },
          }}
        >
          Progress
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: "rgba(255,255,255,0.9)",
            fontWeight: 600,
            fontSize: { xs: "0.7rem", sm: "0.75rem" },
          }}
        >
          {Math.round(progress)}%
        </Typography>
      </Box>
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{
          height: 6,
          borderRadius: 3,
          backgroundColor: "rgba(255,255,255,0.2)",
          "& .MuiLinearProgress-bar": {
            borderRadius: 3,
            background: "linear-gradient(90deg, #ffd89b 0%, #19547b 100%)",
            transition: "width 0.5s ease-in-out",
          },
        }}
      />
    </Box>
  );
};

export default ProcessProgress;
